import { SemanticMarker, type CharacterBody } from '@/schema/character'

export function setMarker(body: CharacterBody, clipId: string, marker: SemanticMarker): CharacterBody {
  const clip = body.clips.find((c) => c.id === clipId)
  if (!clip) throw new Error('This animation clip no longer exists.')
  const checked = SemanticMarker.parse(marker)
  if (checked.frame >= clip.frames) throw new Error('Choose a frame inside this clip.')
  const others = (clip.semantic_markers ?? []).filter((m) => m.id !== checked.id)
  if (others.some((m) => m.kind === checked.kind && m.action === checked.action && m.frame === checked.frame)) {
    throw new Error('This action moment is already marked at this frame.')
  }
  return { ...body, clips: body.clips.map((c) => c.id === clipId ? { ...c, semantic_markers: [...others, checked].sort((a, b) => a.frame - b.frame) } : c) }
}

export function removeMarker(body: CharacterBody, clipId: string, markerId: string): CharacterBody {
  return { ...body, clips: body.clips.map((c) => c.id === clipId ? { ...c, semantic_markers: (c.semantic_markers ?? []).filter((m) => m.id !== markerId) } : c) }
}

export function acceptMarkerSuggestion(body: CharacterBody, clipId: string,
  proposal: { base_rev: number; source_id: string; marker: SemanticMarker }, current: { rev: number; source_id: string }): CharacterBody {
  if (proposal.base_rev !== current.rev || proposal.source_id !== current.source_id || proposal.marker.source_id !== current.source_id) {
    throw new Error('The animation or annotation changed. Request new suggestions.')
  }
  const { reviewed_by: _reviewer, ...marker } = proposal.marker
  return setMarker(body, clipId, { ...marker, review_state: 'pending' })
}

/** Only geometry/timing/pixels affect review identity; adding a marker cannot invalidate itself. */
export function markerGeometry(body: CharacterBody): CharacterBody {
  return { ...body, clips: body.clips.map(({ semantic_markers: _markers, ...clip }) => clip) }
}
